import { Flex, Sheet, Spinner } from '@cellula/react';
import { useConstant } from '@visiba/react-std';
import { Timer } from '@visiba/std';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
	src: string;
	trigger: JSX.Element;
}

export function IframeSheet(props: Props): JSX.Element {
	const [showIframe, setShowIframe] = useState(false);
	const timer = useConstant(() => new Timer());

	useEffect(() => {
		return () => {
			timer.flush();
		};
	}, [timer]);

	function handleClose() {
		timer.wait(() => {
			setShowIframe(false);
		}, 350);
	}

	function handleOpen() {
		timer.wait(() => {
			setShowIframe(true);
		}, 350);
	}

	return (
		<Sheet onOpen={handleOpen} onClose={handleClose} trigger={props.trigger}>
			{showIframe ? (
				<HackyIframe src={props.src} />
			) : (
				<Flex justify='center' align='center' grow='1'>
					<Spinner size='large' />
				</Flex>
			)}
		</Sheet>
	);
}

const StyledIframe = styled.iframe`
	all: unset;
	width: 100%;
	height: 90vh;
`;

function HackyIframe(props: { src: string }): JSX.Element {
	return <StyledIframe allowFullScreen title='-' src={props.src} />;
}
